export default __webpack_public_path__ + "static/tree-shadow-76c970d9fd499053b5f66b094b681663.jpg";